<template>
    <span>
        <TInput
            step="0.01"
            :value="value" 
            type='number'
            @input.stop="e => $emit('input', e.target.value)"></TInput>
    </span>
</template>
<script>
import { TInput } from "@roonlabs/vue-tailwind"
export default {
    name: 'FloatInput',
    components: { TInput },
    props: {
        value: {
            type: Number,
            default: 0.0
        }
    },
}
</script>
